export let noteValues = {
  'C0': 16.35,
  'Cs0': 17.32,
  'D0': 18.35,
  'Ds0': 19.45,
  'E0': 20.60,
  'F0': 21.83,
  'Gb0': 23.12,
  'G0': 24.50,
  'Gs0': 25.96,
  'A0': 27.50,
  'Bb0': 29.14,
  'B0': 30.87,
  'C1': 32.70,
  'Cs1': 34.65,
  'D1': 36.71,
  'Ds1': 38.89,
  'E1': 41.20,
  'F1': 43.65,
  'Fs1': 46.25,
  'G1': 49.00,
  'Gs1': 51.91,
  'A1': 55.00,
  'As1': 58.27,
  'B1': 61.74,
  'C2': 65.41,
  'Cs2': 69.30,
  'D2': 73.42,
  'Ds2': 77.78,
  'E2': 82.41,
  'F2': 87.31,
  'Fs2': 92.50,
  'G2': 98.00,
  'Gs2': 103.83,
  'A2': 110.00,
  'As2': 116.54,
  'B2': 123.47,
  'C3': 130.81,
  'Cs3': 138.59,
  'D3': 146.83,
  'Ds3': 155.56,
  'E3': 164.81,
  'F3': 174.61,
  'Fs3': 185.00,
  'G3': 196.00,
  'Gs3': 207.65,
  'A3': 220.00,
  'As3': 233.08,
  'B3': 246.94,
  'C4': 261.63,
  'Cs4': 277.18,
  'D4': 293.66,
  'Ds4': 311.13,
  'E4': 329.63,
  'F4': 349.23,
  'Fs4': 369.99,
  'G4': 392.00,
  'Gs4': 415.30,
  'A4': 440.00,
  'As4': 466.16,
  'B4': 493.88,
  'C5': 523.25,
  'Cs5': 554.37,
  'D5': 587.33,
  'Ds5': 622.25,
  'E5': 659.26,
  'F5': 698.46,
  'Fs5': 739.99,
  'G5': 783.99,
  'Gs5': 830.61,
  'A5': 880.00,
  'As5': 932.33,
  'B5': 987.77,
  'C6': 1046.50,
  'Cs6': 1108.73,
  'D6': 1174.66,
  'Ds6': 1244.51,
  'E6': 1318.51,
  'F6': 1396.91,
  'Fs6': 1479.98,
  'G6': 1567.98,
  'Gs6': 1661.22,
  'A6': 1760.00,
  'As6': 1864.66,
  'B6': 1975.53,
  'C7': 2093.00,
  'Cs7': 2217.46,
  'D7': 2349.32,
  'Ds7': 2489.02,
  'E7': 2637.02,
  'F7': 2793.83,
  'Fs7': 2959.96,
  'G7': 3135.96,
  'Gs7': 3322.44,
  'A7': 3520.00,
  'As7': 3729.31,
  'B7': 3951.07,
  'C8': 4186.01
}

export let testBoard = {
  'C3': { keycode: 81, freq: 130.81, class: 'white' },
  'Cs3': { keycode: 50, freq: 138.59, class: 'black' },
  'D3': { keycode: 87, freq: 146.83, class: 'white' },
  'Ds3': { keycode: 51, freq: 155.56, class: 'black' },
  'E3': { keycode: 69, freq: 164.81, class: 'white' },
  'F3': { keycode: 82, freq: 174.61, class: 'white' },
  'Fs3': { keycode: 53, freq: 185.00, class: 'black' },
  'G3': { keycode: 84, freq: 196.00, class: 'white' },
  'Gs3': { keycode: 54, freq: 207.65, class: 'black' },
  'A3': { keycode: 89, freq: 220.00, class: 'white' },
  'As3': { keycode: 55, freq: 233.08, class: 'black' },
  'B3': { keycode: 85, freq: 246.94, class: 'white' },
  'C4': { keycode: 90, freq: 261.63, class: 'white' },
  'Cs4': { keycode: 83, freq: 277.18, class: 'black' },
  'D4': { keycode: 88, freq: 293.66, class: 'white' },
  'Ds4': { keycode: 68, freq: 311.13, class: 'black' },
  'E4': { keycode: 67, freq: 329.63, class: 'white' },
  'F4': { keycode: 86, freq: 349.23, class: 'white' },
  'Fs4': { keycode: 71, freq: 369.99, class: 'black' },
  'G4': { keycode: 66, freq: 392.00, class: 'white' },
  'Gs4': { keycode: 72, freq: 415.30, class: 'black' },
  'A4': { keycode: 78, freq: 440.00, class: 'white' },
  'As4': { keycode: 74, freq: 466.16, class: 'black' },
  'B4': { keycode: 77, freq: 493.88, class: 'white' }
}